

<template>
  <div class="body-view" style="background-image: url('static/img/body-bg.png');">
    <div class="top">
      明白卡 —— 险种分类
    </div>
    <div class="list" >
      <img src="static/img/logo-green.png" class="logo" alt />
      <div class="item" @click="toList('T01')">
        <div class="item-bg">
          <div class="bg-filter bg-filter-color-1"></div>
<!--          <img src="static/img/item-bg.png" class="image-bg" style="z-index: 2;opacity: 0.5;" alt />-->
          <img src="static/img/item-bg-1-img.png" class="image-bg"  alt />
        </div>
        <div class="item-name">种 植 险</div>
      </div>
      <div class="item" @click="toList('T02')">
        <div class="item-bg">
          <div class="bg-filter bg-filter-color-2"></div>
<!--          <img src="static/img/item-bg.png" class="image-bg" alt />-->
          <img src="static/img/item-bg-2-img.png" class="image-bg"  alt />
        </div>
        <div class="item-name">养 殖 险</div>
      </div>
      <div class="item" @click="toList('T03')">
        <div class="item-bg">
          <div class="bg-filter bg-filter-color-3"></div>
<!--          <img src="static/img/item-bg.png" class="image-bg" alt />-->
          <img src="static/img/item-bg-3-img.png" class="image-bg"  alt />
        </div>
        <div class="item-name">森 林 险</div>
      </div>
<!--      <div class="item">-->
<!--        <div class="item-bg">-->
<!--          <div class="bg-filter bg-filter-color-4"></div>-->
<!--          <img src="static/img/item-bg.png" class="image-bg" alt />-->
<!--        </div>-->
<!--        <div class="item-name">大棚险</div>-->
<!--      </div>-->
      <div style="width: 100%;height: 50px"></div>
    </div>
  </div>
</template>
<script setup>
  export default {
    data(){
      return{

      }
    },
    methods:{
      toList(type){
        this.$router.push({
          path: "/knowlist",
          query: {
            type: type,
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  body{
    background-color:#f6fff8 !important;
  }
  .body-view{
    width: 100%;
    min-height: 100vh;
    height: auto;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: bottom;
    background-color: #f6fff8 ;
    //background-color: #e1ffe7 !important;
    .top{
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      border-bottom: #e5b1fb 1px solid;
      position: fixed;
      top: 0;
      z-index: 100;
      background-color: #f6fff8 ;

    }
    .list{
      width: 100%;
      //min-height: calc(100vh - 50px);
      height: auto;

      .logo{
        width: 70vw;
        margin-left: 15vw;
        margin-top: -20vw;
      }
      .item{
        width: 90vw;
        height: 30vw;
        background: #FFFFFF;
        //border: #2B9C00 1px solid;
        margin: 5vw;
        position: relative;
        border-radius: 5vw;
        overflow: hidden;
        .item-bg{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          .bg-filter{

            opacity: 0.7;
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
          }
          .bg-filter-color-1{
            background: linear-gradient(to right, #ffffff00, #000000)
          }
          .bg-filter-color-2{
            background: linear-gradient(to right, #ffffff00, #000000)
          }
          .bg-filter-color-3{
            background: linear-gradient(to right, #ffffff00, #000000)
          }
          .bg-filter-color-4{
            background: #fff700;
          }
          .image-bg{
            width: 100%;
            height: 100%;
            position: absolute;
          }
        }

        .item-name{
          position: absolute;
          font-size: 8vw;
          font-weight: bold;
          top: 7vw;
          left: 45vw;
          color: #faffdf;
          text-shadow: 0px 0px 6px black;
          z-index:2;
          //background-color: #ffffff6e;
          padding: 1vw 3vw;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/KnowCard/knowCard.vue